import { Component, Mixins } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import suggestionsListsQuery from '../../queries/suggestionsLists';
import { SuggestionsList } from '../../types/api-copied';
import { UtilMixin } from '../../UtilMixin';
import PaginationMixin from '../../PaginationMixin';
import Pager from '../shared/pager.vue';
import { ViewerContext } from '../../types/viewer_context';

@Component({ components: { Pager } })
export default class SuggestionsListsGrid extends Mixins(
  UtilMixin,
  PaginationMixin
) {
  @Getter public viewerContext!: ViewerContext;

  public readonly query = suggestionsListsQuery;

  public getStateLabelForSuggestionsList(suggestionsList: SuggestionsList) {
    let text: any;
    switch (suggestionsList.state) {
      case 'IN_PROGRESS':
        text = this.$t('common.suggestionsList.state.in_progress');
        break;
      case 'CHANGES_REQUESTED':
        text = this.$t('common.suggestionsList.state.changes_requested');
        break;
      case 'SUBMITTED':
        text = this.$t('common.suggestionsList.state.submitted');
        break;
      case 'CLOSED':
        text = this.$t('common.suggestionsList.state.submitted');
        break;
    }
    return text;
  }

  public get queryVariables() {
    return {
      bookshopId: this.viewerContext.institutionId,
      onlyUnsolicited: false,
      states: ['IN_PROGRESS', 'SUBMITTED', 'CHANGES_REQUESTED'],
      first: this.first,
      last: this.last,
      after: this.after,
      before: this.before,
    };
  }

  public suggestionsListLink(suggestionsList: SuggestionsList): any {
    if (suggestionsList.state === 'CLOSED') {
      throw new Error('Cant create a link for project');
    }
    return {
      name: 'suggestionsList',
      params: { suggestionsListId: suggestionsList.id },
    };
  }
}
